import { useAPIContext } from "../../../context/APIContext";
import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import Loader from "../../../Layouts/Loader/Loader";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";
import HttpRequestTemplateEditor from "./HttpRequestTemplateEditor";

const HttpRequestTemplateApiSection = (props) => {
  const { file } = props;
  const { setSelectedApiData, selectedApiData } = useAPIContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchHttpsTemplate = async (id, endpoint) => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance.get(`/${endpoint}/${id}`);
        setSelectedApiData(data);
      } catch (err) {
        handleApiError(err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHttpsTemplate(file.id, "http-request-templates");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  if (!selectedApiData) return null;

  return (
    <HttpRequestTemplateEditor file={file} selectedApiData={selectedApiData} setSelectedApiData={setSelectedApiData} />
  );
};

export default HttpRequestTemplateApiSection;
